<template>
  <div class="etc" :style="{ paddingBottom: active === 1 ? '184px' : '' }">
    <div class="etc_main">
      <div class="etc_topbar">
        <!-- <i class="reportPreviewLogo"></i> -->
      </div>
      <div class="etc_content">
        <div class="operations">
          <button
            class="pageBack"
            @click="handleDialogPreview(1)"
            v-if="type === 0"
          >
            <i
              class="icon_pc"
            />预&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;览<br />电子证书
          </button>
          <button
            class="pageBack"
            @click="handleDialogPreview(2)"
            v-if="type === 0"
          >
            <i
              class="icon_ck"
            />预&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;览<br />查验卡片
          </button>
          <button
            class="pageBack"
            @click="type === 0 ? handleClosePage() : $router.go(-1)"
          >
            <i :class="`${type === 0 ? 'btn_close' : 'icon_back'}`" />{{
              type === 0 ? "关闭预览" : "返回上页"
            }}
          </button>
        </div>
        <div
          v-if="active === 1 && type !== 0"
          class="shareToWechat"
          @mousemove="shareQrShow = true"
          @mouseout="shareQrShow = false"
        >
          <i class="trigle"></i>
          <div class="shareToWechatQr" v-show="shareQrShow">
            <div class="miniQr">
              <!-- <q-rcode
                :QRlink="`https://www.chrivc.com/api/consumer/wechatshare/getUrlLink?path=%2Fpages%2FreportPreview%2FreportPreview&query=type%3D2%26active%3D1%26id%3D${id}`"
                :qrheight="283"
                :qrwidth="283"
              /> -->
              <v-qr
                :text="
                  `https://www.chrivc.com/api/consumer/wechatshare/getUrlLink?b=2&query=source%3D2%26type%3D2%26active%3D1%26id%3D${id}`
                "
                :logo="require('../../assets/favicon.png')"
                qrcodeColor="#000000ff"
                backgroundColor="#ffffffff"
                :size="200"
                :logoSize="50"
                :margin="10"
                :ratio="1"
                level="M"
              />
            </div>
            <div>
              <div>使用微信扫一扫</div>
              <div>分享电子证书</div>
            </div>
          </div>
        </div>
        <!-- <div class="steps" v-if="type === 0">
          <div class="step" @click="active = 1">
            <div class="circle">1</div>
            预览电子证书和卡片
          </div>
          <div class="line"></div>
          <div class="step" @click="active = 2">
            <div class="circle">2</div>
            预览报告
          </div>
        </div> -->
        <img
          src="https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/certificate.png"
          id="imgload"
          ref="imgload"
          alt=""
          style="opacity: 0;
    position: absolute;
    left: -9999px;top:-9999px"
        />

        <div class="step1" v-if="active === 1">
          <div class="title">电子证书</div>
          <div class="description" v-if="type === 0">（图示为样例展示）</div>
          <div class="certificate" ref="certificate" v-show="showCert">
            <div class="logoList"></div>
            <div class="title">&nbsp;</div>
            <div style="line-height: 35px;font-size:20px;color:#6E6E6E">
              <div>姓名：{{ certificateInfo.username }}</div>
              <div ref="idCard">身份证号：{{ certificateInfo.idCard }}</div>
            </div>
            <div class="detail" style="">
              该人才数据档案由溯源优才——全国人力资源信息数据验证平台全程溯源和验证，由{{
                certificateInfo.username
              }}本人发起数据档案数据报告申请。凭证书可在官方指定平台查询其数据档案数据报告。本证书的最终解释权归发证机构所有。
            </div>
            <div class="otherInfo">
              <div
                style="
    display: flex;
    width: 100%;
    justify-content: space-between;
"
              >
                <div>
                  发证日期：{{
                    certificateInfo.createDate | parseTime("{y}-{m}-{d}")
                  }}
                </div>
                <div v-if="certificateInfo.endDate">
                  有效期至：{{
                    certificateInfo.endDate | parseTime("{y}-{m}-{d}")
                  }}
                </div>
                <div v-else>有效期至：长期有效</div>
              </div>
              <!-- <div>
                发证日期：
              </div>
              <div v-if="certificateInfo.endDate">
                有效期至：{{
                  certificateInfo.endDate | parseTime("{y}-{m}-{d}")
                }}
              </div> -->
              <!-- <div v-else>有效期至：长期有效</div> -->
              <!-- <div>区块链存证信息：{{ certificateInfo.blockchain }}</div> -->
              <div style="display: flex;flex-direction: column;">
                <div>区块链存证信息：</div>
                <div style="max-width: 400px;word-break: break-all;flex: 1;">
                  {{ certificateInfo.blockchain }}
                </div>
              </div>
            </div>
            <div class="certificateFoot">
              <div class="qrcode">
                <q-rcode
                  :QRlink="
                    `${
                      type === 0
                        ? 'https://www.chrivc.com'
                        : 'https://www.chrivc.com/api/consumer/wechatshare/getUrlLink?b=2&query=type%3D2%26active%3D3%26id%3D' +
                          id
                    }`
                  "
                  :qrheight="150"
                  :qrwidth="150"
                />
                <div class="scanTip">
                  <div>
                    请扫描二维码
                  </div>
                  <div>查验个人信息报告</div>
                </div>
              </div>
              <div class="pic_zhang"></div>
            </div>
          </div>
          <div class="title">查验卡片</div>
          <div class="description" v-if="type === 0">（图示为样例展示）</div>
          <div class="checkQrCard" ref="checkQrCard">
            <!-- <div class="logoBar"> -->
            <!-- <div class="logo"></div> -->
            <!-- <span class="name">&nbsp;</span> -->
            <!-- </div> -->
            <!-- <div class="subTitle">&nbsp;</div> -->
            <div class="bgQrcode">
              <!-- <q-rcode
                :QRlink="'http://www.baidu.com'"
                :qrheight="283"
                :qrwidth="283"
              /> -->
              <v-qr
                :text="
                  `${
                    type === 0
                      ? 'https://www.chrivc.com'
                      : 'https://www.chrivc.com/api/consumer/wechatshare/getUrlLink?b=2&query=source%3D2%26type%3D2%26active%3D3%26id%3D' +
                        id
                  }`
                "
                :logo="require('../../assets/favicon.png')"
                qrcodeColor="#000000ff"
                backgroundColor="#ffffffff"
                :size="300"
                :logoSize="50"
                :margin="10"
                :ratio="1"
                level="M"
              />
              <!-- <vue-qr text="http://www.baidu.com"></vue-qr> -->
            </div>
          </div>
        </div>
        <div class="step2" v-else>
          <div class="topTitle">
            <div class="topTitleLine"></div>
            <div class="topTitleLayout">
              <div class="topMainTitle">个人信息查验报告</div>
              <div class="createDate">
                生成时间：{{ reportDate | parseTime("{y}-{m}-{d} {h}:{i}") }}
              </div>
            </div>
            <div class="topTitleLine"></div>
          </div>
          <div class="topTip">
            【溯源优才】个人信息查验报告是在当事人的授权或直接操作下，根据【全国人力资源信息数据验证平台】的国家人力资源信息数据库中留存的数据记录生成，所有数据项均可溯源防伪，<span
              >报告记录和查验记录均永久保存留档。</span
            >
          </div>
          <div class="sourceSwitch" v-if="isSourceSwitchShow">
            <el-checkbox v-model="showSource">显示数据来源</el-checkbox>
            <div style="display:flex;margin-top:31px">
              <span style="margin-right:45px"
                ><i class="icon_source SYSTEM"></i
                >来源于国家公信力权威部门</span
              >
              <span style="margin-right:45px"
                ><i class="icon_source CONSUMER"></i>来源于本人自填</span
              >
              <span
                ><i class="icon_source BUSINESS"></i
                >来源于学校/企业/社会机构</span
              >
            </div>
            <!-- <el-checkbox>不显示数据来源</el-checkbox> -->
          </div>
          <div class="reportList">
            <div class="reportItem" v-if="report['基础信息']">
              <div class="reportTitle">基础信息</div>
              <div class="reportBody">
                <div class="reportName">
                  <div v-if="report['基础信息']['姓名']">
                    姓名：{{ report["基础信息"]["姓名"].dataValue
                    }}<Source
                      v-if="showSource"
                      iconType="self"
                      :isCer="true"
                      :source="report['基础信息']['姓名'].dataSourceType"
                      :dataSourceName="
                        report['基础信息']['姓名'].dataSourceName
                      "
                    />
                  </div>
                  <div v-if="report['基础信息']['性别']">
                    性别：{{ report["基础信息"]["性别"].dataValue
                    }}<Source
                      v-if="showSource"
                      iconType="self"
                      :isCer="true"
                      :source="report['基础信息']['性别'].dataSourceType"
                      :dataSourceName="
                        report['基础信息']['性别'].dataSourceName
                      "
                    />
                  </div>
                </div>
                <div class="other">
                  <div class="value" v-if="report['基础信息']['身份证号']">
                    <div>身份证号：</div>
                    <div>
                      {{ report["基础信息"]["身份证号"].dataValue
                      }}<Source
                        v-if="showSource"
                        iconType="self"
                        :isCer="true"
                        :source="report['基础信息']['身份证号'].dataSourceType"
                        :dataSourceName="
                          report['基础信息']['身份证号'].dataSourceName
                        "
                      />
                    </div>
                  </div>
                  <div class="value" v-if="report['基础信息']['出生日期']">
                    <div>出生日期：</div>
                    <div>
                      {{ report["基础信息"]["出生日期"].dataValue
                      }}<Source
                        v-if="showSource"
                        iconType="self"
                        :isCer="true"
                        :source="report['基础信息']['出生日期'].dataSourceType"
                        :dataSourceName="
                          report['基础信息']['出生日期'].dataSourceName
                        "
                      />
                    </div>
                  </div>
                  <div class="value" v-if="report['基础信息']['民族']">
                    <div>民族：</div>
                    <div>
                      {{ report["基础信息"]["民族"].dataValue
                      }}<Source
                        v-if="showSource"
                        iconType="self"
                        :isCer="true"
                        :source="report['基础信息']['民族'].dataSourceType"
                        :dataSourceName="
                          report['基础信息']['民族'].dataSourceName
                        "
                      />
                    </div>
                  </div>
                  <div class="value" v-if="report['基础信息']['身份证注册地']">
                    <div>身份证注册地：</div>
                    <div>
                      {{ report["基础信息"]["身份证注册地"].dataValue
                      }}<Source
                        v-if="showSource"
                        iconType="self"
                        :isCer="true"
                        :source="
                          report['基础信息']['身份证注册地'].dataSourceType
                        "
                        :dataSourceName="
                          report['基础信息']['身份证注册地'].dataSourceName
                        "
                      />
                    </div>
                  </div>
                  <div class="value" v-if="report['基础信息']['手机号码']">
                    <div>手机号码：</div>
                    <div class="list">
                      <div
                        v-for="(item, index) in report['基础信息']['手机号码']"
                        :key="index"
                      >
                        {{ item["值"].dataValue
                        }}<Source
                          v-if="showSource"
                          iconType="self"
                          :isCer="true"
                          :source="item['值'].dataSourceType"
                          :dataSourceName="item['值'].dataSourceName"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="value" v-if="report['基础信息']['座机号码']">
                    <div>座机号码：</div>
                    <div class="list">
                      <div
                        v-for="(item, index) in report['基础信息']['座机号码']"
                        :key="index"
                      >
                        {{ item["值"].dataValue
                        }}<Source
                          v-if="showSource"
                          iconType="self"
                          :source="item['值'].dataSourceType"
                          :dataSourceName="item['值'].dataSourceName"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="value" v-if="report['基础信息']['通信地址']">
                    <div>通信地址：</div>
                    <div class="list">
                      <div
                        v-for="(item, index) in report['基础信息']['通信地址']"
                        :key="index"
                      >
                        {{ item["值"].dataValue
                        }}<Source
                          v-if="showSource"
                          iconType="self"
                          :source="item['值'].dataSourceType"
                          :dataSourceName="item['值'].dataSourceName"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="value" v-if="report['基础信息']['电子邮箱']">
                    <div>电子邮箱：</div>
                    <div class="list">
                      <div
                        v-for="(item, index) in report['基础信息']['电子邮箱']"
                        :key="index"
                      >
                        {{ item["值"].dataValue
                        }}<Source
                          v-if="showSource"
                          iconType="self"
                          :source="item['值'].dataSourceType"
                          :dataSourceName="item['值'].dataSourceName"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="value" v-if="report['基础信息']['政治面貌']">
                    <div>政治面貌：</div>
                    <div>
                      {{ report["基础信息"]["政治面貌"].dataValue
                      }}<Source
                        v-if="showSource"
                        iconType="self"
                        :source="report['基础信息']['政治面貌'].dataSourceType"
                        :dataSourceName="
                          report['基础信息']['政治面貌'].dataSourceName
                        "
                      />
                    </div>
                  </div>
                  <div class="value" v-if="report['基础信息']['婚姻状况']">
                    <div>婚姻状况：</div>
                    <div>
                      {{ report["基础信息"]["婚姻状况"].dataValue
                      }}<Source
                        v-if="showSource"
                        iconType="self"
                        :source="report['基础信息']['婚姻状况'].dataSourceType"
                        :dataSourceName="
                          report['基础信息']['婚姻状况'].dataSourceName
                        "
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="reportItem" v-if="report['学历教育']">
              <div class="reportTitle">学历教育</div>
              <div class="reportBody">
                <!--  -->
                <div class="eduList">
                  <div
                    class="eduItem"
                    v-for="(item, index) in report['学历教育']"
                    :key="index"
                  >
                    <div class="eduTitleBar">
                      <div class="eduTitle">
                        {{ item["教育机构"].dataValue
                        }}<Source
                          v-if="showSource"
                          iconType="self"
                          :source="item['教育机构'].dataSourceType"
                          :dataSourceName="item['教育机构'].dataSourceName"
                        />
                      </div>
                      <div class="date">
                        <!-- {{
                          item["时间"].dataValue.split(",")[0] +
                            "至" +
                            item["时间"].dataValue.split(",")[1]
                        }} -->
                        {{
                          item["时间"].dataValue.split(",").length > 1
                            ? `${item["时间"].dataValue.split(",")[0]}~${
                                item["时间"].dataValue.split(",")[1]
                              }`
                            : `${item["时间"].dataValue.split(",")[0]}`
                        }}
                      </div>
                    </div>
                    <div class="eduMajors">
                      <div
                        style="display: flex;justify-content: space-between;"
                      >
                        <div class="items">
                          <span v-if="item['专业名称']">{{
                            item["专业名称"].dataValue
                          }}</span>
                          <span v-if="item['学制']">{{
                            item["学制"].dataValue
                          }}</span>
                          <span v-if="item['是否全日制']">{{
                            item["是否全日制"].dataValue
                          }}</span>
                          <span v-if="item['专业层次']">{{
                            item["专业层次"].dataValue
                          }}</span>
                          <span v-if="item['教育结果']">{{
                            item["教育结果"].dataValue
                          }}</span>
                        </div>
                        <FilePreview
                          v-if="item['附件']"
                          :files="item['附件'].dataValue.split(',')"
                          @handleClick="handlePreview"
                        />
                      </div>
                      <div class="schedule" v-if="item['班期']">
                        班期：{{ item["班期"].dataValue }}
                      </div>
                      <div class="eduDescription" v-if="item['专业描述']">
                        {{ item["专业描述"].dataValue }}
                      </div>
                      <div
                        class="eduEvent"
                        v-if="report['学历教育'][index]['事件/活动记录']"
                      >
                        事件/活动记录：
                      </div>
                      <div class="timeline">
                        <el-timeline>
                          <el-timeline-item
                            v-for="(event, index) in report['学历教育'][index][
                              '事件/活动记录'
                            ]"
                            :key="index"
                          >
                            <div class="content">
                              <!-- {{
                                event["时间"].dataValue.split(",")[0] +
                                  (event["时间"].dataValue.split(",").length >
                                    1 && "至") +
                                  event["时间"].dataValue.split(",")[1]
                              }} -->
                              {{
                                event["时间"].dataValue.split(",").length > 1
                                  ? `${event["时间"].dataValue.split(",")[0]}~${
                                      event["时间"].dataValue.split(",")[1]
                                    }`
                                  : `${event["时间"].dataValue.split(",")[0]}`
                              }}
                              {{ event["内容"].dataValue }}
                            </div>
                            <!-- <div class="fileBox">
                              <div class="icon_file"></div>
                              {{
                                event["附件"].dataValue.split(",").length
                              }}个附件
                            </div> -->
                            <FilePreview
                              v-if="event['附件']"
                              :files="event['附件'].dataValue.split(',')"
                              @handleClick="handlePreview"
                            />
                          </el-timeline-item>
                        </el-timeline>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="reportItem" v-if="report['非学历教育']">
              <div class="reportTitle">非学历教育</div>
              <div class="reportBody">
                <div class="eduList">
                  <div
                    class="eduItem"
                    v-for="(item, index) in report['非学历教育']"
                    :key="index"
                  >
                    <div class="eduTitleBar">
                      <div class="eduTitle" wx:if="">
                        {{ item["教育机构"] && item["教育机构"].dataValue
                        }}<Source
                          v-if="showSource"
                          iconType="self"
                          :source="item['教育机构'].dataSourceType"
                          :dataSourceName="item['教育机构'].dataSourceName"
                        />
                      </div>
                      <div class="date" v-if="item['时间']">
                        <!-- {{
                          item["时间"].dataValue.split(",").length > 1
                            ? item["时间"].dataValue.split(",")[0] +
                              "至" +
                              item["时间"].dataValue.split(",")[1]
                            : item["时间"].dataValue.split(",")[0]
                        }} -->
                        {{
                          item["时间"].dataValue.split(",").length > 1
                            ? `${item["时间"].dataValue.split(",")[0]}~${
                                item["时间"].dataValue.split(",")[1]
                              }`
                            : `${item["时间"].dataValue.split(",")[0]}`
                        }}
                      </div>
                    </div>
                    <div class="eduMajors">
                      <div class="desc" v-if="item['机构描述']">
                        {{ item["机构描述"].dataValue }}
                      </div>

                      <div
                        style="display: flex;justify-content: space-between;"
                      >
                        <div class="items">
                          <span>{{
                            item["教育产品"] && item["教育产品"].dataValue
                          }}</span>
                          <span>{{
                            item["教育结果"] && item["教育结果"].dataValue
                          }}</span>
                        </div>

                        <FilePreview
                          v-if="item['附件']"
                          :files="item['附件'].dataValue.split(',')"
                          @handleClick="handlePreview"
                        />
                      </div>
                      <div class="schedule" v-if="item['班期']">
                        班期：{{ item["班期"] && item["班期"].dataValue }}
                      </div>
                      <div class="eduDescription">
                        {{ item["产品描述"] && item["产品描述"].dataValue }}
                      </div>
                      <div
                        class="eduEvent"
                        v-if="report['非学历教育'][index]['事件/活动记录']"
                      >
                        事件/活动记录：
                      </div>
                      <div class="timeline">
                        <el-timeline>
                          <el-timeline-item
                            v-for="(event, index) in report['非学历教育'][
                              index
                            ]['事件/活动记录']"
                            :key="index"
                          >
                            <div class="content" v-if="event['时间']">
                              <!-- {{
                                event["时间"].dataValue.split(",")[0] +
                                  (event["时间"].dataValue.split(",").length >
                                    1 && "至") +
                                  event["时间"].dataValue.split(",")[1]
                              }} -->
                              {{
                                event["时间"].dataValue.split(",").length > 1
                                  ? event["时间"].dataValue.split(",")[0] +
                                    "~" +
                                    event["时间"].dataValue.split(",")[1]
                                  : event["时间"].dataValue.split(",")[0]
                              }}
                              {{ event["内容"] && event["内容"].dataValue }}
                            </div>
                            <FilePreview
                              v-if="event['附件']"
                              :files="event['附件'].dataValue.split(',')"
                              @handleClick="handlePreview"
                            />
                            <!-- <div class="fileBox">
                              <div class="icon_file"></div>
                              {{
                                event["附件"].dataValue.split(",").length
                              }}个附件
                            </div> -->
                          </el-timeline-item>
                        </el-timeline>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="reportItem" v-if="report['职业经历']">
              <div class="reportTitle">职业经历</div>
              <div class="reportBody">
                <div class="eduList">
                  <div
                    class="eduItem"
                    v-for="(item, index) in report['职业经历']"
                    :key="index"
                  >
                    <div class="eduTitleBar">
                      <div class="eduTitle">
                        {{ item["单位名称"].dataValue
                        }}<Source
                          v-if="showSource"
                          :dataSourceName="item['单位名称'].dataSourceName"
                          :source="item['单位名称'].dataSourceType"
                        />
                      </div>
                      <div class="date">
                        {{
                          item["时间"].dataValue.split(",").length > 1
                            ? `${item["时间"].dataValue.split(",")[0]}~${
                                item["时间"].dataValue.split(",")[1]
                              }`
                            : `${item["时间"].dataValue.split(",")[0]}`
                        }}
                      </div>
                    </div>
                    <div class="eduMajors">
                      <div class="desc" v-if="item['单位介绍']">
                        {{ item["单位介绍"].dataValue }}
                      </div>
                      <!-- <div class="schedule">
                        班期：{{ item["班期"].dataValue }}
                      </div> -->
                      <div
                        style="display: flex;justify-content: space-between;"
                      >
                        <FilePreview
                          v-if="item['附件']"
                          :files="item['附件'].dataValue.split(',')"
                          @handleClick="handlePreview"
                        />
                      </div>
                      <!-- <div class="eduDescription">
                        {{ item["产品描述"].dataValue }}
                      </div> -->
                      <div
                        class="eduEvent"
                        v-if="report['职业经历'][index]['岗位记录']"
                      >
                        岗位记录：
                      </div>
                      <div class="timeline">
                        <el-timeline>
                          <el-timeline-item
                            v-for="(event, index) in report['职业经历'][index][
                              '岗位记录'
                            ]"
                            :key="index"
                          >
                            <div class="postCotent">
                              <div class="pc_top">
                                <div class="postName">
                                  {{ event["岗位名称"].dataValue }}
                                </div>
                                <div class="postDate">
                                  <!-- {{
                                    event["时间"].dataValue.split(",")[0] +
                                      (event["时间"].dataValue.split(",")
                                        .length > 1 && "至") +
                                      event["时间"].dataValue.split(",")[1]
                                  }} -->
                                  {{
                                    event["时间"].dataValue.split(",").length >
                                    1
                                      ? `${
                                          event["时间"].dataValue.split(",")[0]
                                        }~${
                                          event["时间"].dataValue.split(",")[1]
                                        }`
                                      : `${
                                          event["时间"].dataValue.split(",")[0]
                                        }`
                                  }}
                                </div>
                              </div>
                              <div class="pc_bottom">
                                {{ event["内容"] && event["内容"].dataValue }}
                              </div>
                            </div>
                            <FilePreview
                              v-if="event['附件']"
                              :files="event['附件'].dataValue.split(',')"
                              @handleClick="handlePreview"
                            />
                          </el-timeline-item>
                        </el-timeline>
                      </div>
                      <div
                        class="eduEvent"
                        v-if="report['职业经历'][index]['事件/活动记录']"
                      >
                        事件/活动记录：
                      </div>
                      <div class="timeline">
                        <el-timeline>
                          <el-timeline-item
                            v-for="(event, index) in report['职业经历'][index][
                              '事件/活动记录'
                            ]"
                            :key="index"
                          >
                            <div class="content">
                              <!-- {{
                                event["时间"].dataValue.split(",")[0] +
                                  (event["时间"].dataValue.split(",").length >
                                    1 && "至") +
                                  event["时间"].dataValue.split(",")[1]
                              }} -->
                              {{
                                event["时间"].dataValue.split(",").length > 1
                                  ? `${event["时间"].dataValue.split(",")[0]}~${
                                      event["时间"].dataValue.split(",")[1]
                                    }`
                                  : `${event["时间"].dataValue.split(",")[0]}`
                              }}
                              {{ event["内容"].dataValue }}
                            </div>
                            <FilePreview
                              v-if="event['附件']"
                              :files="event['附件'].dataValue.split(',')"
                              @handleClick="handlePreview"
                            />
                          </el-timeline-item>
                        </el-timeline>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="reportItem" v-if="report['社会活动经历']">
              <div class="reportTitle">社会活动经历</div>
              <div class="reportBody">
                <div class="eduList" v-if="report['社会活动经历']">
                  <div class="eduItem">
                    <div class="timeline">
                      <!-- {{
                        report["社会活动经历"][0]["事件/活动记录"][0]["时间"]
                          .dataValue
                      }} -->
                      <!-- <div v-for="(event,index) in report['社会活动经历'][0]['事件/活动记录']" :key="index">{{event}}</div> -->
                      <el-timeline>
                        <el-timeline-item
                          v-for="(event, index) in report['社会活动经历'][0][
                            '事件/活动记录'
                          ]"
                          :key="index"
                        >
                          <div class="content" v-if="event['时间']">
                            <!-- {{
                                event["时间"].dataValue.split(",")[0] +
                                  (event["时间"].dataValue.split(",").length >
                                    1 && "至") +
                                  event["时间"].dataValue.split(",")[1]
                              }} -->
                            <!-- {{
                              event["时间"].dataValue.split(",").length > 1
                                ? event["时间"].dataValue.split(",")[0] +
                                  "至" +
                                  event["时间"].dataValue.split(",")[1]
                                : event["时间"].dataValue.split(",")[0]
                            }} -->
                            {{
                              event["时间"].dataValue.split(",").length > 1
                                ? `${event["时间"].dataValue.split(",")[0]}~${
                                    event["时间"].dataValue.split(",")[1]
                                  }`
                                : `${event["时间"].dataValue.split(",")[0]}`
                            }}
                            <Source
                              v-if="showSource"
                              :dataSourceName="event['时间'].dataSourceName"
                              :source="event['时间'].dataSourceType"
                            />
                            <div>
                              {{ event["内容"] && event["内容"].dataValue }}
                            </div>
                            <Source
                              v-if="showSource"
                              :dataSourceName="event['内容'].dataSourceName"
                              :source="event['内容'].dataSourceType"
                            />
                          </div>
                          <FilePreview
                            v-if="event['附件']"
                            :files="event['附件'].dataValue.split(',')"
                            @handleClick="handlePreview"
                          />
                        </el-timeline-item>
                      </el-timeline>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="footer"></div> -->
      <div class="zw"></div>
      <div class="disclaimers" v-if="active === 2">
        <div>免责声明：</div>
        <ul>
          <li>
            1.
            本次个人信息查验报告由溯源优才——全国人力资源信息数据验证平台出具，报告依据截至报告时点的全国人力资源信息数据验证平台记录的数据档案生成，未包含此后增删修改的更新数据内容。
          </li>
          <li>
            2.
            报告中所有数据均由本人自填或数据相关机构提供，平台不保证其真实性和准确性，但承担在信息汇总、整合的过程中保持客观、中立的地位。
          </li>
          <li>
            3. 本报告整合了数据提供机构以信息主体不同证件报送的信息。
          </li>
          <li>
            4.
            数据来源中本人自填是信息主体对数据档案的自主填写，信息主体自填时已承诺对本人自填的所有信息真实性负责。
          </li>
          <li>
            5.
            数据来源中学校/企业/社会组织机构是数据相关机构写入，数据提供机构承诺对数据信息真实性负责。
          </li>
          <li>
            6.
            本报告内容涉及个人隐私，查看者应依法使用，妥善保管。因使用不当造成个人信息泄露的，溯源优才——全国人力资源信息数据验证平台将不承担相关责任。
          </li>
        </ul>
      </div>
    </div>
    <div
      class="etc_footer"
      v-if="(type === 0 && active === 1) || (type === 1 && active === 1)"
    >
      <Btn
        v-if="type === 0"
        btnText="预览报告"
        :width="158"
        :fontSize="16"
        @handleClick="previewReport"
      />
      <Btn
        v-if="type === 1"
        btnText="下载电子证书"
        subText="（显示身份证号码）"
        :width="150"
        :fontSize="14"
        @handleClick="saveCertificate"
      />
      <Btn
        v-if="type === 1"
        btnText="下载电子证书"
        subText="（隐藏身份证号码）"
        :width="150"
        :fontSize="14"
        @handleClick="saveCertificateNoIdCard"
        style="margin-left:20px"
      />
      <Btn
        v-if="type === 1"
        btnText="下载查验卡片"
        :width="150"
        :fontSize="14"
        @handleClick="saveCard"
        style="margin-left:20px"
      />
      <Btn
        v-if="type === 1"
        btnText="申请纸质证书"
        :width="150"
        :fontSize="14"
        @handleClick="getPaper"
        style="margin-left:20px"
      />
    </div>
    <div v-if="dialogPreview">
      <DialogImgsPreview
        :imgs="previewImgs"
        @handleClose="handleDialogPreviewClose"
      />
    </div>

    <CoverLayout v-if="dialogCert">
      <div class="dialogCert" slot="content">
        <div class="pre" @click="dialogCertStep = 1"></div>
        <div class="certBox" v-if="dialogCertStep === 1">
          <div class="title">
            电子证书（样例）
            <div class="icon_close" @click="dialogCert = false"></div>
          </div>
          <div class="certContent">
            <div class="sampleText">（样例）</div>
            <div class="l1">
              <div>姓名：{{ certificateInfo.username }}</div>
              <div>身份证号：{{ certificateInfo.idCard }}</div>
            </div>
            <div class="l2">
              该人才数据档案由溯源优才——全国人力资源信息数据验证平台全程溯源和验证，由{{
                certificateInfo.username
              }}本人发起数据档案数据报告申请。凭证书可在官方指定平台查询其数据档案数据报告。本证书的最终解释权归发证机构所有。
            </div>
            <div class="otherInfo">
              <div
                style="
    display: flex;
    width: 100%;
    justify-content: space-between;
"
              >
                <div>
                  发证日期：{{
                    certificateInfo.createDate | parseTime("{y}-{m}-{d}")
                  }}
                </div>
                <div v-if="certificateInfo.endDate">
                  有效期至：{{
                    certificateInfo.endDate | parseTime("{y}-{m}-{d}")
                  }}
                </div>
                <div v-else>有效期至：长期有效</div>
              </div>
            </div>
            <div style="display: flex;flex-direction: column;">
              <div>区块链存证信息：</div>
              <div
                style="max-width: 400px;filter:blur(2px);word-break: break-all;flex: 1;"
              >
                {{ certificateInfo.blockchain }}
              </div>
            </div>
            <div class="certificateFoot">
              <div class="qrcode">
                <!-- <q-rcode
                  :blur="true"
                  :QRlink="
                    `${
                      type === 0
                        ? 'https://www.chrivc.com'
                        : 'https://www.chrivc.com/api/consumer/wechatshare/getUrlLink?b=2&query=type%3D2%26active%3D3%26id%3D' +
                          id
                    }`
                  "
                  :qrheight="70"
                  :qrwidth="70"
                /> -->
                <div class="cert"></div>
                <div>请扫描二维码</div>
                <div>查验个人信息报告</div>
              </div>
              <div class="pic_zhang"></div>
            </div>
          </div>
        </div>
        <div class="cardBox" v-else>
          <div class="title">
            查验卡片（样例）
            <div class="icon_close" @click="dialogCert = false"></div>
          </div>

          <div class="cardContent">
            <div class="red">（样例）</div>
            <!-- <v-qr
                :text="
                  `${
                    type === 0
                      ? 'https://www.chrivc.com'
                      : 'https://www.chrivc.com/api/consumer/wechatshare/getUrlLink?b=2&query=type%3D2%26active%3D3%26id%3D' +
                        id
                  }`
                "
                :logo="require('https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/favicon.png')"
                qrcodeColor="#000000ff"
                backgroundColor="#ffffffff"
                :size="280"
                :logoSize="50"
                :margin="10"
                :ratio="1"
                level="M"
              /> -->
            <div class="card"></div>
          </div>
        </div>
        <div class="next" @click="dialogCertStep = 2"></div>
      </div>
    </CoverLayout>
  </div>
</template>

<script>
import Btn from "../../components/Btn.vue";
import {
  reportPreview,
  certificateDetail,
  reportCreateDate
} from "@/api/report";
import Source from "../../components/Source.vue";
import CoverLayout from "../../components/CoverLayout.vue";
import DialogImgsPreview from "../../components/DialogImgsPreview.vue";
import FilePreview from "../../components/FilePreview.vue";
import { visitReport } from "@/api/inspection";
import QRcode from "../../components/QRcode.vue";
import html2canvas from "html2canvas";
import { Loading } from "element-ui";
// import VueQr from 'vue-qr'
export default {
  components: {
    Btn,
    Source,
    CoverLayout,
    DialogImgsPreview,
    FilePreview,
    QRcode
  },
  data() {
    return {
      step: 1,
      id: undefined,
      type: undefined,
      showSource: false,
      report: {},
      dialogPreview: false,
      previewImgs: [],
      userInfo: {},
      active: 1,
      certificateInfo: {
        id: "",
        username: "", //JSON.parse(sessionStorage.getItem("userInfo")).username,
        idCard: "", //JSON.parse(sessionStorage.getItem("userInfo")).idCard,
        createDate: "", //"1658218283",
        blockchain: "" //"123123xxxxxxlakjdljf"
      },
      isSourceSwitchShow: true,
      shareQrShow: false,
      // type:0预览，1自看报告，查看他人报告2
      // active:1 证书，2报告
      dialogCert: false,
      dialogCertStep: 1,
      showCert: false,
      reportDate: ""
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.active = Number(this.$route.query.active);
    this.type = Number(this.$route.query.type);
    this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    let that = this;
    this.$nextTick(() => {
      let img = new Image();
      img = document.getElementById("imgload");
      img.onload = function() {
        //
        if (that.type === 0) {
          that.dialogCert = true;
        } else {
          that.showCert = true;
        }
      };
    });
    this.getReportCreateDate(this.id);
    switch (this.type) {
      case 0:
        // console.log("case0");
        this.report = JSON.parse(localStorage.getItem("reportView"));
        this.certificateInfo = {
          username: this.userInfo.name,
          idCard: this.userInfo.idCard,
          blockchain:
            "ef932fd1e8938cd6668878b5e115c8bf5b3d48e7bdbc66cc5f8774c6d294da49",
          createDate: Math.floor(new Date().getTime() / 1000),
          endDate: null
        };
        this.active = 2;

        break;
      case 1:
        if (this.active === 1) {
          this.getCertificate(this.id);
        } else {
          this.getReport({ id: this.id });
        }
        break;
      case 2:
        this.getVisitReport(this.id);
        break;
      default:
        break;
    }
    // if (this.type === 1) {
    //   console.log("type1");
    //   this.getReport({ id: this.id });
    // } else if (this.type === 2) {
    //   if (this.active === 1) {
    //     this.getCertificate(this.id);
    //   } else {
    //     this.getVisitReport(this.id);
    //   }
    // } else {
    //   this.report = JSON.parse(localStorage.getItem("reportView"));
    // }
  },
  methods: {
    saveCertificate() {
      this.$nextTick(() => {
        // let hideEl = this.$refs.certificate;
        // console.log(hideEl);
        // hideEl
        // document.body.appendChild(hideEl)
        html2canvas(this.$refs.certificate).then(res => {
          let imgUrl = res.toDataURL("image/png");
          // console.log('图片临时地址',imgUrl)
          let aLink = document.createElement("a");
          aLink.href = imgUrl;
          aLink.download = "溯源优才人才证书_" + this.id + ".png"; //导出文件名，这里以时间命名
          document.body.appendChild(aLink);
          // 模拟a标签点击事件
          aLink.click();
          // 事件已经执行，删除本次操作创建的a标签对象
          document.body.removeChild(aLink);
          // // 以服务的方式调用的 Loading 需要异步关闭
          setTimeout(() => {
            Loading.service().close();
            console.log("图片导出成功");
          }, 10);
        });
      });
    },
    saveCertificateNoIdCard() {
      console.log(this.$refs.idCard);
      this.$refs.idCard.style = "display:none";
      this.$nextTick(() => {
        html2canvas(this.$refs.certificate).then(res => {
          let imgUrl = res.toDataURL("image/png");
          let aLink = document.createElement("a");
          aLink.href = imgUrl;
          aLink.download = "溯源优才人才证书_" + this.id + ".png"; //导出文件名，这里以时间命名
          document.body.appendChild(aLink);
          aLink.click();
          document.body.removeChild(aLink);
          setTimeout(() => {
            Loading.service().close();
            this.$refs.idCard.style = "display:inline-block";
            console.log("图片导出成功");
          }, 10);
        });
      });
    },
    saveCard() {
      this.$nextTick(() => {
        html2canvas(this.$refs.checkQrCard).then(res => {
          let imgUrl = res.toDataURL("image/png");
          // console.log('图片临时地址',imgUrl)
          let aLink = document.createElement("a");
          aLink.href = imgUrl;
          aLink.download = "溯源优才人才证书_卡片_" + this.id + ".png"; //导出文件名，这里以时间命名
          document.body.appendChild(aLink);
          // 模拟a标签点击事件
          aLink.click();
          // 事件已经执行，删除本次操作创建的a标签对象
          document.body.removeChild(aLink);
          // // 以服务的方式调用的 Loading 需要异步关闭
          setTimeout(() => {
            Loading.service().close();
            console.log("图片导出成功");
          }, 10);
        });
      });
    },
    getReport(payload) {
      reportPreview(payload).then(res => {
        this.report = res.data.d;
      });
    },
    getVisitReport(payload) {
      visitReport(payload).then(res => {
        if (res.data.c === 501010) {
          this.$message.error(res.data.m);
          this.isSourceSwitchShow = false;
          setTimeout(() => {
            this.$router.go(-1);
          }, 3000);
        } else {
          this.report = res.data.d;
        }
      });
    },
    getCertificate(id) {
      certificateDetail(id).then(res => {
        this.certificateInfo = res.data.d;
      });
    },
    handlePreview(data) {
      this.previewImgs = data;
      this.dialogPreview = true;
    },
    handleDialogPreview(step) {
      this.dialogCert = true;
      this.dialogCertStep = step;
    },
    handleDialogPreviewClose() {
      this.dialogPreview = false;
    },
    previewReport() {
      this.active = 2;
    },
    handleClosePage() {
      window.opener = null;
      window.open("about:blank", "_top").close();
    },
    getReportCreateDate(id) {
      reportCreateDate(id).then(res => {
        // console.log(res);
        this.reportDate = res.data.d;
      });
    },
    getPaper() {
      this.$message.warning("暂未开通，敬请等待");
    }
  }
};
</script>

<style lang="scss" scoped>
.etc {
  background: #f0f2f5;
  .etc_main {
    width: 1000px;
    margin: 0 auto;
    background: #fff;
    .etc_topbar {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/etc_topbar.png")
        no-repeat;

      // background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/etc_topbar.png")no-repeat;
      background-size: cover;
      height: 165px;
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: center;
      .reportPreviewLogo {
        background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/reportPreviewLogo.png")
          no-repeat;
        background-size: cover;
        display: inline-block;
        width: 194px;
        height: 38px;
      }
    }
    .etc_content {
      // display: flex;
      // flex-direction: column;
      // align-items: center;
      position: relative;
      padding: 0 60px 12px 60px;
      .operations {
        position: absolute;
        right: -124px;
      }
      .pageBack {
        margin-top: 15px;
        box-sizing: content-box;
        cursor: pointer;
        border: 1px solid #96abd9;
        border-radius: 6px;
        width: 102px;
        min-height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #9b9b9b;
        line-height: 20px;
        &:first-child {
          margin-top: 0;
        }
        .icon_back {
          background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_arrow_left.png");
          background-size: cover;
          margin-right: 8px;
          width: 7px;
          height: 12px;
          display: inline-block;
        }
        .btn_close {
          background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/btn_close.png");
          background-size: cover;
          margin-right: 7px;
          width: 10px;
          height: 10px;
          display: inline-block;
        }
        .icon_pc {
          background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_pc.png");
          background-size: cover;
          margin-right: 7px;
          width: 31px;
          height: 31px;
          display: inline-block;
        }
        .icon_ck {
          background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_ck.png");
          background-size: cover;
          margin-right: 7px;
          width: 31px;
          height: 31px;
          display: inline-block;
        }
      }
      .steps {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 43px;
        margin-bottom: 20px;
        .line {
          width: 112px;
          height: 3px;
          background: #ededed;
          margin-left: 32px;
          margin-right: 30px;
        }
        .step {
          display: flex;
          // flex-direction: column;
          cursor: pointer;
          align-items: center;
          flex-direction: row;
          .circle {
            background: #3a61b1;
            width: 39px;
            height: 39px;
            border-radius: 39px;
            color: #fff;
            font-size: 22.36px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 16px;
          }
        }
      }
      .step1 {
        display: flex;
        flex-direction: column;
        align-items: center;
        .certificate {
          width: 727px;
          height: 1039px;
          // border: 1px solid #eee;
          box-sizing: border-box;
          padding: 137px 117px 157px 118px;
          // background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/certificate.png")
          //   no-repeat;
          background: url("../../assets/certificate.png") no-repeat;
          background-size: cover;
          .logoList {
            width: 231px;
            height: 98px;
          }
          .title {
            font-size: 50.49px;
            color: #393939;
            text-align: center;
            font-family: "PingFang SC";
            font-weight: bold;
          }
          .otherInfo {
            font-size: 16px;
            color: #000;
            display: flex;
            flex-direction: column;
            // align-items: center;
            line-height: 30px;
            // text-align: center;
            margin-top: 25px;
          }
          .certificateFoot {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 10px;
            .qrcode {
              margin-top: 23px;
              font-size: 14px;
              color: #6e6e6e;
              .scanTip {
                margin-left: 20px;
              }
            }
            .pic_zhang {
              background: url("../../assets/pic_zhang.png") no-repeat;
              background-size: cover;
              width: 172px;
              height: 172px;
              // animation: GaiZhang 0.75s cubic-bezier(0.4, 0, 1, 1);
            }
          }
          .detail {
            margin-top: 20px;
            line-height: 37px;
            color: #393939;
            font-size: 20px;
            font-weight: bold;
            // text-align: center;
          }
        }
        .title {
          font-size: 20px;
          color: #393939;
          margin-top: 25px;
          margin-bottom: 19px;
        }
        .description {
          font-size: 16px;
          color: #8d8d8d;
          margin-bottom: 31px;
        }
        .checkQrCard {
          width: 429px;
          height: 546px;
          // border: 1px solid #eee;
          background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/checkQrCard.png")
            no-repeat;
          background-size: cover;
          display: flex;
          flex-direction: column;
          align-items: center;
          // justify-content: space-evenly;
          box-sizing: border-box;
          padding: 68px 30px 0px 30px;
          margin-bottom: 62px;
          box-sizing: content-box;
          .logoBar {
            display: flex;
            justify-content: center;
            align-items: center;
            .logo {
              background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/logo.png")
                no-repeat;
              background-size: cover;
              width: 42px;
              height: 43px;
              margin-right: 18px;
            }
            .name {
              font-size: 47.77px;
              color: #3a61b1;
            }
          }

          .subTitle {
            margin-top: 23px;
            margin-bottom: 37px;
            font-size: 22.72px;
            color: #3a61b1;
          }
          .bgQrcode {
            padding: 10px;
            background: #fff;
            border-radius: 10px;
            margin-top: 145px;
          }
        }
      }
      .step2 {
        margin-top: 20px;
        .icon_source {
          display: inline-block;
          position: relative;
          top: 2px;
          margin-right: 5px;
        }
        .SYSTEM {
          width: 15px;
          height: 17px;
          background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/SYSTEM.png")
            no-repeat;
          background-size: cover;
        }
        .CONSUMER {
          width: 15px;
          height: 15px;
          background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/CONSUMER.png")
            no-repeat;
          background-size: cover;
        }
        .BUSINESS {
          width: 17px;
          height: 17px;
          background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/BUSINESS.png")
            no-repeat;
          background-size: cover;
        }
        .reportList {
          .reportItem {
            margin-bottom: 40px;
            .reportTitle {
              font-size: 20px;
              color: #393939;
              font-weight: bold;
              position: relative;
              padding-left: 10px;
              margin-bottom: 22px;
              margin-top: 40px;
              &::before {
                content: "";
                border-left: 3px solid #3a61b1;
                height: 16px;
                padding-left: 10px;
                position: absolute;
                top: 5px;
                left: 0;
              }
            }
            .reportBody {
              border: 1px solid #f1f1f1;
              box-sizing: border-box;
              padding: 38px 33px 48px 33px;
              line-height: 50px;
              color: #393939;
              .reportName {
                display: flex;
                justify-content: space-between;
              }
              .other {
                line-height: 61px;
                .value {
                  display: flex;
                  .list {
                    display: flex;
                    flex-direction: column;
                  }
                }
              }
              .eduList {
                .eduItem {
                  .eduTitleBar {
                    display: flex;
                    justify-content: space-between;
                    .eduTitle {
                      font-size: 22px;
                      color: #393939;
                      font-weight: bold;
                    }
                    .date {
                      font-size: 16px;
                      color: #c3c3c3;
                    }
                  }
                  .eduMajors {
                    padding-left: 20px;

                    .desc {
                      color: #6e6e6e;
                      font-size: 14px;
                    }
                    .eduEvent {
                      font-weight: bold;
                    }
                    .eduDescription {
                      color: #6e6e6e;
                      font-size: 14px;
                    }

                    span {
                      position: relative;
                      font-size: 16px;
                      padding-right: 10px;
                      &:not(:last-child) {
                        &:after {
                          content: "";
                          border-right: 2px solid #f4f4f4;
                          position: absolute;
                          right: 0;
                          height: 16px;
                          top: 3px;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    // .footer {
    //   background: rgba(58, 97, 177, 0.25);
    //   height: 74px;
    //   width: 100%;
    // }
    .zw {
      height: 74px;
      width: 100%;
      background: #f0f2f5;
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/report_bottomBg.png")
        no-repeat;
      background-size: cover;
    }
    .disclaimers {
      // margin-top: 45px;
      font-size: 14px;
      color: #6e6e6e;
      padding: 67px 110px 46px 90px;
      background: #fff;
      ul {
        list-style: none;
        padding-left: 0;
        margin-top: 22px;
        li {
          margin-bottom: 22px;
        }
      }
    }
  }
  .etc_footer {
    height: 130px;
    position: fixed;
    width: 100%;
    bottom: 0;
    box-shadow: 0px 0px 12px 5px rgb(58 97 177 / 18%);
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  >>> .timeline {
    display: inline-block;
    width: 100%;
    .content {
      line-height: 27px;
    }
    .postCotent {
      .pc_top {
        display: flex;
        justify-content: space-between;
        .postName {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #393939;
          line-height: 30px;
        }
        .postDate {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #c3c3c3;
          line-height: 30px;
        }
      }
      .pc_bottom {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #6e6e6e;
        line-height: 28px;
      }
    }

    // margin-top: 20px;
    .el-input__prefix {
      .el-icon-date {
        display: none;
      }
    }
    .el-form-item {
      margin-bottom: 20px;
    }
    .el-date-editor--year,
    .el-date-editor--month,
    .el-date-editor--date {
      .el-input__inner {
        padding-left: 18px;
      }
    }
    .timeLineOptions {
      position: absolute;
      right: 0;
      top: 13px;
      color: #3a61b1;
      span {
        margin-left: 15px;
      }
    }
    .el-timeline-item__tail {
      position: absolute;
      left: 5px;
      top: 15px;
      height: 100%;
      border-left: 1px solid #3a61b1;
    }
    .el-timeline-item__wrapper {
      position: relative;
      padding-left: 33px;
      top: 3px;
    }
    .el-timeline-item__node {
      background-color: #3a61b1;
    }
    .el-timeline-item__node--normal {
      left: 2px;
      width: 7px;
      height: 7px;
      top: 13px;
    }
    .dateContent {
      color: #393939;
      font-size: 16px;
    }
    .timestamp {
      color: #878787;
      font-size: 16px;
    }
    .updatePostForm {
      .el-upload__tip {
        margin-top: 0;
      }
      .el-upload--text {
        color: #3a61b1;
        text-decoration: underline;
      }
      .btn_submit {
        width: 69px;
        height: 30px;
        background: #3a61b1;
        border-radius: 15px;
        color: #fff;
        border: 0;
        margin-right: 13px;
        cursor: pointer;
      }
      .btn_cancel {
        width: 69px;
        height: 30px;
        background: #e7ecf6;
        border: 1px solid #3a61b1;
        border-radius: 15px;
        color: #3a61b1;
        cursor: pointer;
      }
      .updatePostItem {
        margin-bottom: 20px;
        label {
          width: 92px;
          text-align: left;
        }
        display: flex;
        .datePickerItem {
          display: flex;
          width: 100%;
          .monthPicker {
            &:last-child {
              margin-right: 0;
            }
          }
        }
        .textareaLayout {
          display: inline-block;
        }
      }

      .el-form-item {
        margin-bottom: 20px;

        .el-form-item__label {
          width: 92px;
          text-align: left;
        }
        .el-form-item__content {
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }
  >>> .el-input__inner {
    border: 1px solid #fce6d4 !important;
  }
  >>> .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #2ec99f;
    border-color: #2ec99f;
  }
  >>> .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #606266;
  }
  >>> .el-checkbox__inner {
    width: 20px;
    height: 20px;
    border: 2px solid #dce0e6;
    border-radius: 4px;
  }
  >>> .el-checkbox__inner::after {
    height: 9px;
    left: 5px;
    position: absolute;
    top: 1px;
    width: 4px;
  }
}
.shareToWechat {
  background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_wechat.png")
    no-repeat;
  background-size: cover;
  width: 44px;
  height: 44px;
  position: absolute;
  right: 65px;
  top: 19px;

  .shareToWechatQr {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 228px;
    height: 275px;
    background: #fff;
    border-radius: 10px;
    position: relative;
    top: 60px;
    left: -97px;
    // box-shadow: 0 0 7px 0 #aeaeae;
    box-shadow: 0 0px 12px 0 #aeaeae;
    padding: 14px;
    box-sizing: border-box;
    text-align: center;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #8d8d8d;
    line-height: 24px;
    .miniQr {
      width: 178px;
      height: 178px;
    }
    // &::before {
    //   box-sizing: content-box;
    //   width: 0px;
    //   height: 0px;
    //   position: absolute;
    //   top: -16px;
    //   left: 110px;
    //   padding: 0;
    //   border-bottom: 8px solid #fff;
    //   border-top: 8px solid rgba(0, 0, 0, 0);
    //   border-left: 8px solid rgba(0, 0, 0, 0);
    //   border-right: 8px solid rgba(0, 0, 0, 0);
    //   display: block;
    //   box-shadow: 0 0 7px 0 #eee;
    //   content: "";
    //   z-index: 12;
    // }
  }
}
.dialogCert {
  // width: 450px;
  display: flex;
  align-items: center;
  height: 686px;

  .pre {
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_pre.png")
      no-repeat;
    background-size: cover;
    width: 39px;
    height: 80px;
    margin-right: 50px;
    cursor: pointer;
  }
  .next {
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_pre.png")
      no-repeat;
    background-size: cover;
    width: 39px;
    height: 80px;
    margin-left: 50px;
    transform: rotate(180deg);
    cursor: pointer;
  }
  .certBox {
    .title {
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #ffffff;
      line-height: 20px;
      margin-bottom: 26px;
      text-align: center;
      position: relative;
      .icon_close {
        background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_close_white.png")
          no-repeat;
        background-size: cover;
        width: 18px;
        height: 18px;
        display: inline-block;
        cursor: pointer;
        position: absolute;
        right: 0;
      }
    }
    .certContent {
      width: 450px;
      height: 643px;
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/certificate.png");
      background-size: cover;
      font-size: 12px;
      box-sizing: border-box;
      padding: 211px 75px 0 75px;
      .sampleText {
        text-align: center;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #d60000;
        line-height: 20px;
      }
      .l1 {
        div {
          margin-bottom: 5px;
        }
      }
      .l2 {
        font-weight: bold;
        color: #393939;
        line-height: 22px;
        margin-top: 10px;
        margin-bottom: 10px;
        text-align: center;
      }
      .certificateFoot {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        .cert {
          background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/previewQr.png")
            no-repeat;
          background-size: cover;
          width: 70px;
          height: 70px;
        }
        .qrcode {
          margin-top: 10px;
          color: #6e6e6e;
        }
        .pic_zhang {
          background: url("../../assets/pic_zhang.png") no-repeat;
          background-size: cover;
          width: 106px;
          height: 106px;
          animation: GaiZhang 0.75s cubic-bezier(0.4, 0, 1, 1);
        }
      }
      .otherInfo {
        margin-bottom: 5px;
      }
      // display: flex;
      // flex-direction: column;
      // align-items: center;
    }
  }
  .cardBox {
    .title {
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #ffffff;
      line-height: 20px;
      margin-bottom: 26px;
      text-align: center;
      position: relative;
      .icon_close {
        background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_close_white.png")
          no-repeat;
        background-size: cover;
        width: 18px;
        height: 18px;
        display: inline-block;
        cursor: pointer;
        position: absolute;
        right: 0;
      }
    }

    .cardContent {
      width: 429px;
      height: 546px;
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/checkQrCard.png");
      background-size: cover;
      font-size: 12px;
      box-sizing: border-box;
      padding: 160px 75px 0 66px;
      .red {
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #d60000;
        line-height: 20px;
        text-align: center;
        margin-bottom: 10px;
      }
      .card {
        background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/previewCard.png")
          no-repeat;
        background-size: cover;
        width: 293px;
        height: 293px;
      }
      .v-qrcode-wrap {
        // filter: blur(2px);
      }
    }
  }
}
@keyframes GaiZhang {
  0% {
    transform: scale(2) rotate(90deg);
    // opacity: 0;
  }
  50% {
    // opacity: 0;
    transform: scale(2) rotate(90deg);
  }
  75% {
    transform: scale(2) rotate(90deg);
    // transform: scale(1.5) rotate(45deg);
  }
  100% {
    transform: scale(1) rotate(0deg);
    // opacity: 1;
  }
}
.topTitle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 25px;
  .topTitleLine {
    width: 321px;
    height: 4px;
    background: #3a61b1;
    opacity: 0.14;
  }
  .topTitleLayout {
    text-align: center;
    .topMainTitle {
      color: #2d57a8;
      font-size: 22px;
    }
    .createDate {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #6e6e6e;
      line-height: 30px;
    }
  }
}
.topTip {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #aeaeae;
  line-height: 24px;
  margin-bottom: 25px;
  span{
    color: #AEAEAE;
    font-weight: 600;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/reportPreview/index.vue